<template>
  <transition name="fade">
    <div class="popup-wrapper" :class="dialogInfo.className" v-show="popupStatus" ref="popupWrapper">
      <div class="shade-wrapper" @click="shadeClickFun"></div>
      <transition name="scale">
        <div class="popup-content" v-show="contentShowStatus">
          <div class="content" :class="dialogInfo.className" :style="'width:'+ dialogInfo.width">
            <div class="title" v-if="dialogInfo.showTitle">{{dialogInfo.title}}</div>
            <div class="info" :class="dialogInfo.align" v-if="dialogInfo.message"  v-html="dialogInfo.message"></div>
            <div class="info" v-else>
              <slot></slot>
            </div>
            <div class="btn-wrapper">
              <div class="btn cancel-btn"
                  v-if="dialogInfo.showCancelBtn"
                  :style="'color:'+ dialogInfo.cancelBtnColor"
                  @click.stop="handleCloseFun">
                {{dialogInfo.cancelText}}
              </div>
              <div class="btn confirm-btn"
                  v-if="dialogInfo.showConfirmBtn"
                  :style="'color:'+ dialogInfo.confirmBtnColor"
                  @click.stop="handleConfirmFun">
                {{dialogInfo.confirmText}}
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'lyyDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    isAutoClose: {
      type: Boolean,
      default: true,
    },
    popupType: {
      type: String,
      default: 'alert',
    },
    shadeCloseOnClick: {
      type: Boolean,
      default: false,
    },
    className: String,
    width: String,
    showTitle: {
      type: Boolean,
      default: true,
    },
    title: String,
    confirmBtnColor: String,
    showConfirmBtn: {
      type: Boolean,
      default: true,
    },
    closeFun: Function,
    confirmFun: Function,
    cancelBtnColor: String,
    cancelText: String,
    confirmText: String,
  },
  watch: {
    value: {
      handler(val, oldval) {
        if (oldval !== undefined) {
          val ? this.handleOpen() : this.handleCloseFun();
        }
      },
      immediate: true,
    },
    confirmBtnColor(val) {
      this.dialogInfo.confirmBtnColor = val;
    },
    cancelBtnColor(val) {
      this.dialogInfo.cancelBtnColor = val;
    },
    confirmText(val) {
      this.dialogInfo.confirmText = val;
    },
  },
  data() {
    return {
      dialogInfo: {},
      popupStatus: false,
      contentShowStatus: false,
      isClick: false,
    };
  },
  methods: {
    handleOpen() {
      const options = { };
      for (const key in this.$props) {
        if (key !== 'value' && key !== 'popupType' && (this.$props[key] || this.$props[key] === false)) {
          options[key] = this.$props[key];
        }
      }
      const popupType = this.$props.popupType;
      if (popupType === 'alert' || popupType === 'confirm') {
        this[popupType](options);
      } else {
        console.log('!!!popupType 传入类型错误！！！');
      }
    },
    // 打开弹窗
    openFun() {
      this.popupStatus = true;
      setTimeout(() => {
        this.contentShowStatus = true;
      }, 10);
    },
    alert(options) {
      this.openFun();
      this.dialogInfo = {
        className: '',
        width: '27rem',
        confirmText: '确定',
        showTitle: true,
        align: 'center',
        shadeCloseOnClick: false,
        showCancelBtn: false,
        showConfirmBtn: true,
        ...options,
      };
    },
    confirm(options) {
      this.dialogInfo = {
        className: '',
        width: '27rem',
        cancelText: '取消',
        confirmText: '确定',
        showTitle: true,
        align: 'center',
        shadeCloseOnClick: false,
        showCancelBtn: true,
        showConfirmBtn: true,
        ...options,
      };
      this.openFun();
    },
    hideDialog() {
      if (this.value) {
        this.$emit('input', false);
      } else {
        this.contentShowStatus = false;
        setTimeout(() => {
          this.popupStatus = false;
        }, 10);
      }
    },
    handleCloseFun() {
      this.hideDialog();
      if (typeof this.dialogInfo.closeFun == 'function' && !this.isClick) {
        this.isClick = true;
        setTimeout(() => {
          this.isClick = false;
        }, 100);
        this.dialogInfo.closeFun();
      }
    },
    handleConfirmFun() {
      if (typeof this.dialogInfo.confirmFun == 'function') {
        this.dialogInfo.confirmFun();
      }
      if (this.isAutoClose) {
        this.hideDialog();
      }
    },
    // 遮罩点击
    shadeClickFun() {
      if (this.dialogInfo.shadeCloseOnClick) {
        this.handleCloseFun();
      }
    },
  },
};
</script>

<style lang="less" scoped>
  .content{
    background: #fff;
    border-radius: 1.2rem;
    display:flex;
    flex-direction: column;
    .title{
      font-weight:bold;
      text-align: center;
      font-size: 1.9rem;
      color: #262626;
      margin-top: 2rem;
    }
    .info{
      padding: 1.6rem 2rem 2rem;
      text-align: justify;
      color: #262626;
      font-size:1.4rem;
      line-height: 2.1rem;
      max-height: 35.5rem;
      overflow-y:auto;
      &.center{
        text-align: center;
      }
      &.left{
        text-align: left;
      }
      &.right{
        text-align: left;
      }
    }
    .btn-wrapper{
      display: flex;
      border-top: 1px solid #E6E6E6;
      .btn{
        flex:1;
        line-height: 5rem;
        text-align: center;
        color: #1A87FF;
        font-size:1.8rem;
        user-select: none;
        &.cancel-btn{
          color: #595959;
        }
        &.confirm-btn {
          border-left: 1px solid #E6E6E6;
        }
      }
    }
  }
  .popup-wrapper {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index:9999;
    display: flex;
    &.fade-enter-active,
    &.fade-leave-active {
      transition: all 0.3s ease;
    }

    &.fade-enter,
    &.fade-leave-to {
      opacity: 0;
    }
    .shade-wrapper {
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.3);
      position: absolute;
      top: 0;
      z-index: -1;
    }
    .popup-content {
      align-self: center;
      margin: 0 auto;
      left: 50%;
      top: 50%;
      position: absolute;
      transform: translate(-50%, -50%);
      &.scale-enter-active {
        animation: Scale 0.15s linear;
      }
      &.scale-leave-active {
        animation: Scale 0.15s reverse;
      }
      @keyframes Scale {
        0% {
          transform: translate(-50%, -50%) scale(0);
        }
        100% {
          transform: translate(-50%, -50%) scale(1);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/lyyDialog/lyyDialog.vue